import {Component, computed, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Tag} from 'primeng/tag';
import {TenderStatus} from '@frontend/shared-api';
import {TenderStatusUtils} from '../../../../../../../phase/tender-status.util';

const TRANSLATION_KEYS: Record<TenderStatus, string> = {
  [TenderStatus.INVITED]: 'project.steps.invitationList.status.invited',
  [TenderStatus.ACCEPTED]: 'project.steps.invitationList.status.accepted',
  [TenderStatus.PREPARED]: 'project.steps.invitationList.status.prepared',
  [TenderStatus.FINISHED]: 'project.steps.invitationList.status.finished',
  [TenderStatus.WON]: 'project.steps.invitationList.status.won',
  [TenderStatus.WAITING_FOR_CUSTOMER]: 'project.steps.invitationList.status.waitingForCustomer',
  [TenderStatus.REJECTED]: 'project.steps.invitationList.status.rejected',
  [TenderStatus.EXPIRED]: 'project.steps.invitationList.status.expired',
  [TenderStatus.LOST]: 'project.steps.invitationList.status.lost',
  [TenderStatus.UNSET]: '',
};

@Component({
  selector: 'app-invitation-status-tag',
  imports: [TranslocoPipe, Tag],
  templateUrl: './invitation-status-tag.component.html',
})
export class InvitationStatusTagComponent {
  readonly status = input.required<TenderStatus | null>();

  protected readonly translationKey = computed(() => {
    const status = this.status();
    return status === null ? '' : TRANSLATION_KEYS[status];
  });

  protected readonly severity = computed(() => {
    const status = this.status();
    return status === null ? 'secondary' : TenderStatusUtils.getStatusSeverity(status);
  });
}
